<template>
  <!-- <figure class="media-left" v-if="!light">
    <div class="level">
      <div class="level-left">
        <people-avatar class="level-item" :person="user" />
      </div>
    </div>
  </figure> -->
  <div class="task-columns">
    <group-button>
      <combobox
        class="action-selector"
        :options="actionOptions"
        :width100="true"
        v-model="action"
      />

      <people-field
        class="action-option people-field"
        ref="assignation-field"
        :people="teamPersons"
        :class="{
          'hidden': action != 'assign_tasks'
        }"
        v-model="person"
      />

      <combobox-status
        class="action-option"
        :narrow="false"
        :flexible="true"
        :task-status-list="currentTaskStatusOptions"
        v-model="statusId"
        :class="{
          'hidden': action != 'change_status'
        }"
      />

      <datepicker
        @opened="onDatepickerOpen"
        @closed="onDatepickerClose"
        :class="{
          'hidden': action != 'set_due_date',
          'date-option': true
        }"
        :key="'dp-open' + datepickerOpen.toString()"
        :style="datepickerStyle"
        wrapper-class="datepicker"
        input-class="date-input input"
        calendar-class="calendar-input"
        :monday-first="true"
        format="d MMMM yyyy"
        v-model="selectedDueDate"
      >
      </datepicker>

      <combobox
        :options="priorityOptions"
        v-model="priority"
        :class="{
          'action-option': true,
          'hidden': action != 'change_priority'
        }"
      />

      <combobox-model
        :models="customActions"
        v-model="customAction"
        :class="{
          'action-option': true,
          'hidden': action != 'run_custom_action'
        }"
      />

      <input
        id="input-revision"
        :class="{
          'preview-revision': true,
          input: true,
          hidden: action != 'publish_revision'
        }"
        type="number"
        :min="revision + 1"
        pattern="[0-9]"
        :placeholder="revision + 1"
        @enter="addPreview"
        v-model.trim="nextRevision"
      />

      <button
        class="add-preview-button"
        :disabled="action != 'publish_revision'"
        :class="{
          'hidden': action != 'publish_revision',
          'button': true
        }"
        @click="addPreview"
      >
        {{ $t('comments.add_preview') }}
      </button>

      <button
        :key="action"
        class="action-button"
        :disabled="action === 'select_action'"
        :class="{
          'button': true,
          'is-primary': true,
        }"
        :style="{
          'background-color': buttonColor
        }"
        @click="confirmAction"
      >
        {{ $t('main.confirmation') }}
      </button>
    </group-button>

    <div class="post-area">
      <div class="attachment-title" v-if="previewForms.length > 0">
        {{ $t('comments.previews') }}
      </div>
      <div
        :key="'preview-' + index"
        class="preview-file"
        v-for="(preview, index) in previewForms"
      >
        <div class="m0">
          {{ shortenText(preview.get('file').name, 40) }}
          <span @click="$emit('remove-preview', preview)">x</span>
        </div>
        <div class="progress-wrapper">
          <div
            class="progress"
            :style="{
              width: (uploadProgress[preview.get('file').name] || 0) + '%'
            }"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { sortPeople } from '@/lib/sorting'
import moment from 'moment-timezone'
import strings from '@/lib/string'
// import { replaceTimeWithTimecode } from '@/lib/render'

import Combobox from './Combobox'
import ComboboxModel from '@/components/widgets/ComboboxModel'
import ComboboxStatus from '@/components/widgets/ComboboxStatus'
import GroupButton from './GroupButton'
import PeopleField from '@/components/widgets/PeopleField'
import Datepicker from 'vuejs-datepicker'

const REVISION_NUMBER_REGEX = /v(\d+)/gi

export default {
  name: 'action-select',

  components: {
    Combobox,
    ComboboxModel,
    ComboboxStatus,
    GroupButton,
    PeopleField,
    Datepicker
  },

  props: {
    fps: {
      type: Number,
      default: 25
    },
    revision: {
      type: Number,
      default: 1
    },
    time: {
      type: Number,
      default: 0
    },
    previewForms: {
      type: Array,
      default: () => []
    }
  },

  data () {
    return {
      datepickerOpen: false,
      person: null,
      currentTeam: [],
      customAction: {},
      customActions: [],
      priority: '0',
      priorityOptions: [
        {
          label: this.$t('tasks.priority.normal'),
          value: '0'
        },
        {
          label: this.$t('tasks.priority.high'),
          value: '1'
        },
        {
          label: this.$t('tasks.priority.very_high'),
          value: '2'
        },
        {
          label: this.$t('tasks.priority.emergency'),
          value: '3'
        }
      ],
      nextRevision: undefined,
      statusId: null,
      selectedDueDate: null,
      action: 'select_action',
      actionOptions: [],
    }
  },

  computed: {
    ...mapGetters([
      'taskTypeMap',
      'taskStatusMap',
      'allCustomActions',
      'assetCustomActions',
      'shotCustomActions',
      'people',
      'currentProduction',
      'personMap',
      'user',
      'uploadProgress',
      'selectedTasks',
      'nbSelectedTasks',
      'taskStatusForCurrentUser',
      'nbSelectedValidations'
    ]),

    currentTaskStatusOptions() {
      var billing = false
      var regular = false
      for (const task of this.selectedTasks) {
        if (this.taskTypeMap.get(task[1].task_type_id).name === 'Billing') { billing = true }
        else { regular = true }
      }
      if (billing && regular) {
        return this.taskStatusForCurrentUser
      } else {
        return this.taskStatusForCurrentUser.filter(stat => {
          return !(!stat.is_billing) === billing || stat.is_default
        })
      }
    },

    teamPersons() {
      return sortPeople(
        this.currentProduction.team.map(personId =>
          this.personMap.get(personId)
        )
      )
    },

    isValidPreviewForm() {
      return (this.previewForms.length &&
        (this.nextRevision === undefined || this.nextRevision > this.revision)
      )
    },

    notEntityBound () {
      // return true if all selected tasks are management or global
      for (const task of this.selectedTasks.values()) {
        if (task.level === 2) { return false }
      }
      return true
    },

    isGlobal () {
      // return true if global tasks are selected
      for (const task of this.selectedTasks.values()) {
        if (!task.project_id) { return true }
      }
      return false
    },

    doneStatusId () {
      for (const key of this.taskStatusMap.keys()) {
        if (this.taskStatusMap.get(key).short_name === 'done') {
          return this.taskStatusMap.get(key).id
        }
      }
      return ''
    },

    currentUrl () {
      return this.$route.path
    },

    currentHost () {
      return window.location.host
    },

    currentEntityType () {
      return this.isCurrentViewAsset ? 'asset' : 'shot'
    },

    isCurrentViewAsset () {
      return this.$route.path.indexOf('asset') > 0 &&
             !this.$route.params.asset_id
    },

    datepickerStyle () {
      var width = '150px'
      if (this.datepickerOpen) {
        width = '250px'
      }
      return {
        width: width,
        'max-width': width,
        'min-width': width
      }
    },

    buttonColor () {
      if (this.action === 'delete_tasks') {
        return '#ff3860'
      } else {
        return '#00b242'
      }
    }
  },

  methods: {
    ...mapActions([
      'assignSelectedTasks',
      'changeSelectedEstimations',
      'createSelectedTasks',
      'deleteSelectedTasks',
      'unassignSelectedTasks',
      'changeSelectedTaskStatus',
      'changeSelectedPriorities',
      'clearSelectedTasks',
      'postCustomAction',
      'addTaskHistory',
      'updateTask'
    ]),

    shortenText: strings.shortenText,

    getRevision(form) {
      if (!form) {
        return undefined
      }
      const file = form.get('file')
      const rgxMatches = file.name.matchAll(REVISION_NUMBER_REGEX)
      const revision = Array.from(rgxMatches).pop()?.[1]
      return revision
    },

    updateActionOptions () {
      this.actionOptions = [
        {
          label: '-- Select action --',
          value: 'select_action'
        },
        {
          label: 'Change status',
          value: 'change_status'
        },
        {
          label: this.$t('menu.assign_tasks'),
          value: 'assign_tasks'
        },
        {
          label: this.$t('tasks.clear_assignations'),
          value: 'clear_assignations'
        },
        {
          label: 'Set due date',
          value: 'set_due_date'
        },
        {
          label: this.$t('menu.change_priority'),
          value: 'change_priority'
        }
      ]
      if (!this.notEntityBound) {
        this.actionOptions.push(
          {
            label: this.$t('menu.create_tasks'),
            value: 'create_tasks'
          },
          {
            label: this.$t('tasks.publish_revision'),
            value: 'publish_revision'
          },
          {
            label: this.$t('menu.generate_playlist'),
            value: 'generate_playlist'
          },
          {
            label: this.$t('menu.run_custom_action'),
            value: 'run_custom_action'
          }
        )
      }
      this.actionOptions.push({
        label: this.$t('menu.delete_tasks'),
        value: 'delete_tasks'
      })
    },

    onDatepickerOpen () {
      this.datepickerOpen = true
    },

    onDatepickerClose () {
      this.datepickerOpen = false
    },

    setCurrentTeam () {
      if ((!this.isGlobal) && this.people.length > 10 && this.currentProduction) {
        this.currentTeam = sortPeople(
          this.currentProduction.team.map((personId) => {
            return this.personMap.get(personId)
          })
        )
      } else {
        this.currentTeam = this.people
      }
    },

    setCustomActions () {
      let isShotSelected = false
      let isAssetSelected = false

      for (const taskId of Object.keys(this.selectedTasks)) {
        const task = this.selectedTasks.get(taskId)
        if (task.sequence_name) {
          isShotSelected = true
        } else {
          isAssetSelected = true
        }
      }

      if (isShotSelected && isAssetSelected) {
        this.customActions = this.allCustomActions
      } else if (isShotSelected) {
        this.customActions = this.shotCustomActions
      } else {
        this.customActions = this.assetCustomActions
      }
    },

    confirmAction () {
      if (this.action === 'assign_tasks') {
        this.assignTasks()
      } else if (this.action === 'change_status') {
        this.changeStatus()
      } else if (this.action === 'clear_assignations') {
        this.clearAssignations()
      } else if (this.action === 'change_priority') {
        this.changePriority()
      } else if (this.action === 'create_tasks') {
        this.createTasks()
      } else if (this.action === 'publish_revision') {
        this.publishPreview()
      } else if (this.action === 'generate_playlist') {
        this.generatePlaylist()
      } else if (this.action === 'run_custom_action') {
        this.runCustomAction()
      } else if (this.action === 'delete_tasks') {
        this.deleteTasks()
      } else if (this.action === 'set_due_date') {
        this.setDueDate()
      }
    },

    addRevisions (commentId = '') {
      for (const task of this.selectedTasks.values()) {
        this.addTaskHistory({
          taskId: task.id,
          assigneeIds: task.assignees,
          statusId: this.doneStatusId
        })
      }
    },

    setDueDate () {
      for (const selectedTaskId of this.selectedTasks.keys()) {
        this.updateTask({
          taskId: selectedTaskId,
          data: {
            due_date: moment.tz(this.selectedDueDate, 'UTC').format('YYYY-MM-DD')
          }
        })
      }
    },

    changeStatus () {
      this.$emit('change-status', '', [], [], this.statusId)
    },

    assignTasks () {
      if (this.person) {
        this.addRevisions()
        if (this.notEntityBound) {
          // Global and Management tasks are allowed to have multiple assignees
          this.assignSelectedTasks({
            personId: this.person.id
          })
        } else {
          this.unassignSelectedTasks({})
            .then(() => {
              this.assignSelectedTasks({
                personId: this.person.id
              })
            })
        }
        // TODO: add isAssignationLoading
      }
    },

    clearAssignations () {
      this.addRevisions()
      this.unassignSelectedTasks({})
    },

    changePriority () {
      this.changeSelectedPriorities({
        priority: Number(this.priority),
        callback: () => {}
      })
    },

    createTasks () {
      // const type = this.$route.path.indexOf('shots') > 0 ? 'shots' : 'assets'
      // this.isCreationLoading = true
      this.createSelectedTasks({
        type: this.currentEntityType + 's',
        projectId: this.currentProduction.id
      })
    },

    publishPreview() {
      // if (!this.isValidPreviewForm) {
      //   return
      // }
      // const taskStatus = this.taskStatusMap.get(this.task_status_id)
      // if (taskStatus.is_feedback_request && this.previewForms.length === 0) {
      //   this.modals.confirmFeedbackPublish = true
      //   return
      // }
      this.$store.commit('CLEAR_UPLOAD_PROGRESS')
      // text = replaceTimeWithTimecode("", this.revision, this.time, this.fps)

      this.nextRevision = Number(this.nextRevision)
      if (isNaN(this.nextRevision) || this.nextRevision < 1) {
        this.nextRevision = undefined
      }

      this.$emit('add-comment', "", [], [], this.doneStatusId, this.nextRevision)
      this.nextRevision = undefined
    },

    addPreview () {
      this.$emit('add-preview')
    },

    generatePlaylist () {
      this.$emit('generate-playlist')
    },

    runCustomAction () {
      this.postCustomAction({
        data: {
          entitytype: this.currentEntityType,
          originurl: this.currentUrl,
          originserver: this.currentHost,
          selection: this.selectedTasks.keys(),
          productionid: this.currentProduction.id,
          userid: this.user.id,
          useremail: this.user.email
        },
        url: this.customAction.url
      })
    },

    deleteTasks () {
      this.deleteSelectedTasks()
        .then(() => {
          this.$emit('task-deleted')
        })
        .catch((err) => {
          console.error(err)
        })
    }
  },

  mounted () {
    this.statusId = this.doneStatusId
    // this.customAction = this.defaultCustomAction
    this.updateActionOptions()
    this.setCustomActions()
    this.setCurrentTeam()
  },

  watch: {
    action () {
      if (this.action === 'assign_tasks') {
        this.$nextTick(() => {
          this.$refs['assignation-field'].focus()
        })
      } else if (this.action === 'set_due_date' && !this.selectedDueDate) {
        this.selectedDueDate = this.selectedTasks.values().next().value.due_date
      }
    },

    previewForms: {
      deep: true,
      immediate: true,
      handler() {
        const form = this.previewForms.findLast(
          form => this.getRevision(form) > 0
        )
        this.nextRevision = this.getRevision(form)
      }
    },

    currentProduction () {
      this.setCurrentTeam()
    },

    people () {
      this.setCurrentTeam()
    },

    nbSelectedTasks () {
      this.updateActionOptions()
      this.setCustomActions()
    },

    task () {
      this.updateActionOptions()
      this.setCustomActions()
    },

    $route () {
      this.updateActionOptions()
      this.setCustomActions()
    }
  }
}

</script>

<style lang="scss" scoped>
.dark textarea:disabled {
  background: #555;
}

.control {
  margin-bottom: 0.1em;
}

.preview-section {
  word-break: break-all;
}

.progress {
  background: $green;
}

.post-button-wrapper {
  margin: 0;

  .button.is-primary {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    height: 34px;
    margin-top: 1px;
  }
}

.is-dragging {
  background-color: $purple;
}

.button.is-primary {
  border-radius: 2em;
}

.button.active {
  background: rgba($green, .5);
}

.status-selector {
  margin: 0;
}

.action-option {
  width: 60%;
  margin: 0;
}

.people-field {
  min-width: 180px;
}

.action-selector {
  width: 100%;
  margin: 0;
  height: 100%;
}

.preview-revision {
  min-width: 5em;
  max-width: 5em;
  margin: 0;
}

.input-revision {
  margin-right: 0;
}

:deep(.status-combo) {
  border-radius: 0 !important;
  width: 100%;
  margin-top: 0;
  height: 42px;
}

:deep(.v-autocomplete-input) {
  width: 100%;
  margin-top: 0;
  margin-bottom: 0 !important;
  height: 42px;
}

:deep(input) {
  border-radius: 0 !important;
}

:deep(select) {
  border-radius: 0;
}

.action-selector :deep(.combobox) {
  border-radius: 10px 0 0 10px;
}

::v-deep .calendar-input {
  right: 0;
}
</style>
